import { useParams } from "react-router-dom";
import { ChatWidget } from "@/components/ChatWidget";

export default function WidgetPage() {
  const { businessId } = useParams();
  return (
    <div className="w-full h-[100dvh] min-h-0 bg-transparent">
      <ChatWidget businessId={businessId} embedded />
    </div>
  );
}
